<template>
  <div>
    <div class="user_content">
      <img src="../../assets/img/trustlook-logo.png" alt="" class="logo" />
      <div class="sign">
        <span @click="jump('/login')">{{ $t('user.SignIn') }}</span>
        <span ref="lang">
          <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
          <el-collapse-transition>
            <ul class="language_selection" v-show="languageStatus">
              <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
              <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
            </ul>
          </el-collapse-transition>
        </span>
      </div>
      <div class="register_container" id="register_container">
        <h2 class="title">{{ $t('user.SignUp') }}</h2>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="signup_ruleForm"
        >
          <div class="name">
            <el-form-item prop="firstName">
              <el-input
                type="text"
                v-model="ruleForm.firstName"
                autocomplete="off"
                :placeholder="$t('user.FirstName')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="lastName">
              <el-input
                type="text"
                v-model="ruleForm.lastName"
                autocomplete="off"
                :placeholder="$t('user.LastName')"
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item prop="email">
            <el-input
              type="email"
              v-model="ruleForm.email"
              autocomplete="off"
              :placeholder="$t('user.Email')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="new-password"
              :placeholder="$t('user.Password')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
              :placeholder="$t('user.ConfirmPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="title">
            <el-input
              type="text"
              v-model="ruleForm.title"
              autocomplete="off"
              :placeholder="$t('user.Title')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="company">
            <el-input
              type="text"
              v-model="ruleForm.company"
              autocomplete="off"
              :placeholder="$t('user.Company')"
              @keyup.enter.native="getEnterCode"
            ></el-input>
          </el-form-item>
          <el-form-item class="private">
            {{ $t('message.registerTip') }}
            <a
              href="https://www.trustlook.com/terms.html"
              target="_blank"
              :title="$t('message.terms')"
              >{{ $t('message.terms') }}</a
            >{{ $t('message.and') }}
            <a
              href="https://www.trustlook.com/privacy.html"
              target="_blank"
              :title="$t('message.privacy')"
              >{{ $t('message.privacy') }}</a
            >
          </el-form-item>
          <el-form-item>
            <div class="btn_sign" @click="submitForm('ruleForm')">
              <i class="el-icon-loading" v-if="loading"></i>{{ $t('user.SignUp') }}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { Message } from 'element-ui'
  import VueRouter from 'vue-router'

  const { isNavigationFailure, NavigationFailureType } = VueRouter

  export default {
    name: 'Register',
    data() {
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('errMsg.emailErr1')))
        }
        if (value) {
          setTimeout(() => {
            // Updated regex to properly handle hyphens and be more standard
            var reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (!reg.test(value)) {
              callback(new Error(this.$t('errMsg.emailErr2')))
            } else {
              callback()
            }
          }, 500)
        }
      }
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('errMsg.passwordErr1')))
        } else if (value.length < 6 || value.length > 20) {
          callback(new Error(this.$t('errMsg.passwordErr2')))
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass')
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('errMsg.confirmPasswordErr1')))
        } else if (value !== this.ruleForm.pass) {
          callback(new Error(this.$t('errMsg.confirmPasswordErr2')))
        } else {
          callback()
        }
      }
      return {
        loading: false,
        languageStatus: false,
        ruleForm: {
          firstName: '',
          lastName: '',
          email: '',
          pass: '',
          checkPass: '',
          title: '',
          company: ''
        },
        rules: {
          firstName: [{ required: true, message: this.$t('errMsg.firstNameErr'), trigger: 'blur' }],
          lastName: [{ required: true, message: this.$t('errMsg.lastNameErr'), trigger: 'blur' }],
          email: [{ validator: validateEmail, trigger: ['blur', 'change'] }],
          pass: [{ validator: validatePass, trigger: 'blur' }],
          checkPass: [{ validator: validatePass2, trigger: 'blur' }],
          title: [{ required: true, message: this.$t('errMsg.titleErr'), trigger: 'blur' }],
          company: [{ required: true, message: this.$t('errMsg.companyErr'), trigger: 'blur' }]
        }
      }
    },
    computed: {
      lang() {
        return this.$store.state.lang
      }
    },
    methods: {
      getEnterCode: function(e) {
        var keyCode = window.event ? e.keyCode : e.which
        if (keyCode == 13) {
          this.submitForm('ruleForm')
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loading = true
            let data = {
              firstName: this.ruleForm.firstName,
              lastName: this.ruleForm.lastName,
              email: this.ruleForm.email,
              password: this.ruleForm.pass,
              title: this.ruleForm.title,
              company: this.ruleForm.company
            }
            axios
              .post('/api/user', data)
              .then(response => {
                this.loading = false
                Message({ type: 'success', message: this.$t('errMsg.tip1'), showClose: true })
                this.$router.push('/login').catch(err => {
                  // to hide the below error message
                  if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
                    throw Error(err)
                  }
                })
              })
              .catch(err => {
                this.loading = false
                Message({ type: 'error', message: err.response.data, showClose: true })
              })
          } else {
            Message({ type: 'error', message: this.$t('errMsg.err1'), showClose: true })
            return false
          }
        })
      },
      jump(url) {
        this.$router.push(url).catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
      },
      downAPP() {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
        if (document.documentElement.clientWidth < 450 && isiOS) {
          document.getElementById('register_container').style.paddingBottom = '160px'
        }
      },
      switchLang(lang) {
        if (lang === this.$store.state.lang) return
        this.$store.commit('switchLang', lang)
        this.languageStatus = false
        Message({
          type: 'success',
          message: this.$t('message.switchSuccessfully'),
          showClose: true
        })
        location.reload()
      }
    },
    mounted() {
      this.downAPP()
      let _this = this
      document.addEventListener('click', e => {
        if (!!_this.$refs.lang && !!_this.$refs.lang.contains(e.target)) return
        _this.languageStatus = false
      })
    }
  }
</script>
<style lang="scss" src="./user.scss" scoped></style>
<style lang="scss" scoped>
  .register_container {
    width: 520px;
    background: $bg-user-color;
    @include box-shadow2;
    @include border-radius(10px);
    box-sizing: border-box;
    padding: 60px 60px;
    color: #f3f6fe;
    .title {
      height: 29px;
      text-align: center;
      font-size: 24px;
      color: $white;
      margin-bottom: 48px;
      font-weight: bold;
      font-family: NexaBold;
    }
    .signup_ruleForm {
      ::v-deep .el-form-item {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      ::v-deep .el-form-item__content {
        text-align: center;
        line-height: 14px;
        font-size: 12px;
        & > a {
          margin: 0 5px;
          cursor: pointer;
          color: $white;
          text-decoration: underline;
          &:hover {
            color: $primary-color;
          }
        }
      }
      .name {
        width: 400px;
        @include flex-space-between;
        ::v-deep .el-input__inner {
          width: 190px;
        }
      }
    }
  }
  @media screen and (max-height: 1000px) {
    .register_container {
      @include absolute-left-top(50%, 150px);
      margin-left: -260px;
    }
  }
  @media screen and (max-width: 450px) {
    .register_container {
      width: 100%;
      padding: 0 40px 30px;
      background: none;
      box-shadow: none;
      left: 0;
      margin-left: 0;
      margin-top: -30px;
      .signup_ruleForm {
        .name {
          width: 100%;
          display: block;
          margin-bottom: 24px;
          ::v-deep .el-input__inner {
            width: 100%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user/register.vue